export enum WebinarProviderEnum {
  ZOOM = 'zoom',
  MS_TEAMS = 'teams'
}
